// This file is automatically generated. Do not edit manually.

import { SalvosSubProjectPlannedStartDateProvider_ReferenceType } from "src/api/generated/tenants/salvos/erp/project/salvosSubProjectPlannedStartDateProvider";
import { IsoDateString } from "src/types/dateTime";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace SalvosProjectApi {
	export async function getSubProjectSchedulingAdvanceDurations(args: {
		projectId: number;
	}): Promise<Record<SalvosSubProjectPlannedStartDateProvider_ReferenceType, number>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/salvos/project/getSubProjectSchedulingAdvanceDurations",
			method: "POST",
			data: {
				projectId: args.projectId,
			},
		});
		return response as Record<SalvosSubProjectPlannedStartDateProvider_ReferenceType, number>;
	}

	export async function calculateSubProjectPlannedStartDate(args: {
		projectId: number;
		subProjectId: number;
		reference: SalvosSubProjectPlannedStartDateProvider_ReferenceType;
		advanceDurationInDays: number;
	}): Promise<IsoDateString | null> {
		const response = await makeAxiosRequest({
			url: "/api/ext/salvos/project/calculateSubProjectPlannedStartDate",
			method: "POST",
			data: {
				projectId: args.projectId,
				subProjectId: args.subProjectId,
				reference: args.reference,
				advanceDurationInDays: args.advanceDurationInDays,
			},
		});
		return response === "" ? null : (response as IsoDateString | null);
	}

	export async function releaseSubProjectAndScheduleActivities(args: {
		subProjectId: number;
		resourceId: number;
	}): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/salvos/project/releaseSubProjectAndScheduleActivities",
			method: "POST",
			data: {
				subProjectId: args.subProjectId,
				resourceId: args.resourceId,
			},
		});
		return response as void;
	}
}
